
import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import DemoModal from '../../components/feature/DemoModal';

const PackagesPage = () => {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  useEffect(() => {
    // Update page title and meta description
    document.title = 'Paketler ve Fiyatlar | 9.900 TL\'den başlayan web tasarım paketleri';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Webcoll web tasarım paketleri ve fiyatları. Başlangıç 9.900 TL, Profesyonel 17.900 TL, Kurumsal 29.900 TL. 3 günde yayında, SEO uyumlu.');
    }

    // Add structured data for pricing
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Webcoll Paketleri",
      "description": "Web tasarım paketleri ve fiyatları",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/paketler`,
      "itemListElement": [
        {
          "@type": "Offer",
          "position": 1,
          "name": "Başlangıç Paketi",
          "description": "Küçük işletmeler için ideal web tasarım paketi",
          "price": "9900",
          "priceCurrency": "TRY",
          "availability": "https://schema.org/InStock",
          "seller": {
            "@type": "Organization",
            "name": "Webcoll"
          }
        },
        {
          "@type": "Offer",
          "position": 2,
          "name": "Profesyonel Paketi",
          "description": "Büyüyen işletmeler için web tasarım paketi",
          "price": "17900", 
          "priceCurrency": "TRY",
          "availability": "https://schema.org/InStock",
          "seller": {
            "@type": "Organization",
            "name": "Webcoll"
          }
        },
        {
          "@type": "Offer",
          "position": 3,
          "name": "Kurumsal Paketi",
          "description": "Büyük şirketler için web tasarım paketi",
          "price": "29900",
          "priceCurrency": "TRY", 
          "availability": "https://schema.org/InStock",
          "seller": {
            "@type": "Organization",
            "name": "Webcoll"
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const packages = [
    {
      name: 'Başlangıç',
      price: '9.900',
      period: 'TL',
      description: 'Küçük işletmeler için ideal',
      features: [
        '5 Sayfa Web Sitesi',
        '3 Günde Yayında',
        'Mobil Uyumlu Tasarım',
        'SEO Temel Optimizasyon',
        'Ücretsiz SSL Sertifikası',
        '1 Yıl Hosting + Domain',
        'İletişim Formu',
        'Google Maps Entegrasyonu',
        'Sosyal Medya Linkleri',
        '1 Ay Ücretsiz Destek'
      ],
      popular: false,
      color: 'from-blue-500 to-cyan-500'
    },
    {
      name: 'Profesyonel',
      price: '17.900',
      period: 'TL',
      description: 'Büyüyen işletmeler için',
      features: [
        '10 Sayfa Web Sitesi',
        '3 Günde Yayında',
        'Premium Tasarım',
        'Gelişmiş SEO Optimizasyon',
        'Ücretsiz SSL Sertifikası',
        '1 Yıl Hosting + Domain',
        'Blog Sistemi',
        'Sosyal Medya Entegrasyonu',
        'Google Analytics',
        'İletişim Formları',
        'Galeri Sistemi',
        '3 Ay Ücretsiz Destek'
      ],
      popular: true,
      color: 'from-purple-500 to-pink-500'
    },
    {
      name: 'Kurumsal',
      price: '29.900',
      period: 'TL',
      description: 'Büyük şirketler için',
      features: [
        'Sınırsız Sayfa',
        '3 Günde Yayında',
        'Özel Tasarım',
        'Profesyonel SEO',
        'Ücretsiz SSL Sertifikası',
        '1 Yıl Hosting + Domain',
        'E-ticaret Hazırlığı',
        'Çoklu Dil Desteği',
        'Admin Paneli',
        'Gelişmiş Analitik',
        'Özel Entegrasyonlar',
        'Performans Optimizasyonu',
        '6 Ay Ücretsiz Destek',
        'Öncelikli Destek'
      ],
      popular: false,
      color: 'from-gray-600 to-gray-800'
    }
  ];

  return (
    <>
      <div className="min-h-screen bg-white">
        <Header />
        
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-purple-700"></div>
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-10 right-10 w-32 h-32 bg-purple-300 rounded-full blur-3xl animate-pulse delay-1000"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-blue-300 rounded-full blur-3xl animate-pulse delay-500"></div>
          </div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Her bütçeye uygun{' '}
              <span className="text-yellow-300">
                profesyonel çözümler
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              İşletmenize uygun paketi seçin, markanızı hemen yayına alın. 
              Tüm paketlerde 3 günde yayında garantisi.
            </p>
          </div>
        </section>

        {/* Packages Section */}
        <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {packages.map((pkg, index) => (
                <div 
                  key={index}
                  className={`relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 ${
                    pkg.popular ? 'border-purple-500 scale-105' : 'border-gray-200 hover:border-blue-300'
                  }`}
                >
                  {pkg.popular && (
                    <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                      <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-full text-sm font-bold">
                        En Popüler
                      </span>
                    </div>
                  )}
                  
                  <div className="text-center mb-8">
                    <div className={`w-16 h-16 bg-gradient-to-br ${pkg.color} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                      <i className="ri-star-line text-white text-2xl"></i>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                    <p className="text-gray-600 mb-6">{pkg.description}</p>
                    <div className="flex items-center justify-center mb-2">
                      <span className="text-5xl font-bold text-gray-900">{pkg.price}</span>
                      <span className="text-xl text-gray-600 ml-2">{pkg.period}</span>
                    </div>
                    <p className="text-sm text-gray-500">Tek seferlik ödeme</p>
                  </div>
                  
                  <ul className="space-y-4 mb-8">
                    {pkg.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center">
                        <i className="ri-check-line text-green-500 text-xl mr-3 flex-shrink-0"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button
                    onClick={() => setIsDemoModalOpen(true)}
                    className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap ${
                      pkg.popular
                        ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600 shadow-lg'
                        : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                    }`}
                  >
                    Hemen Başla
                    <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Comparison */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Tüm Paketlerde <span className="text-blue-600">Ortak Özellikler</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Hangi paketi seçerseniz seçin, bu özellikler her zaman dahil.
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-timer-flash-line',
                  title: '3 Günde Yayında',
                  description: 'Hızlı teslimat garantisi'
                },
                {
                  icon: 'ri-smartphone-line',
                  title: 'Mobil Uyumlu',
                  description: 'Tüm cihazlarda mükemmel görünüm'
                },
                {
                  icon: 'ri-search-eye-line',
                  title: 'SEO Uyumlu',
                  description: 'Google\'da üst sıralarda yer alın'
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: 'Teknik Destek',
                  description: '7/24 uzman destek hizmeti'
                }
              ].map((feature, index) => (
                <div 
                  key={index}
                  className="text-center p-6 bg-gradient-to-br from-blue-50 to-purple-50 rounded-2xl hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className={`${feature.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-blue-600 to-purple-700 relative overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-10 right-10 w-32 h-32 bg-purple-300 rounded-full blur-3xl animate-pulse delay-1000"></div>
          </div>
          
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
              Hangi paketi seçeceğinize{' '}
              <span className="text-yellow-300">karar veremediniz mi?</span>
            </h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-12">
              Uzman ekibimizle görüşün, size en uygun paketi birlikte belirleyelim. 
              Ücretsiz danışmanlık hizmeti.
            </p>
            
            <button
              onClick={() => setIsDemoModalOpen(true)}
              className="px-10 py-5 bg-white text-blue-600 font-bold text-lg rounded-2xl hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              Ücretsiz Danışmanlık Al
              <i className="ri-phone-line ml-3 text-xl"></i>
            </button>
          </div>
        </section>

        {/* WhatsApp Floating Button */}
        <div className="fixed bottom-6 right-6 z-50">
          <a
            href="https://wa.me/905451485952"
            target="_blank"
            rel="noopener noreferrer"
            className="w-16 h-16 bg-green-500 hover:bg-white/20 hover:backdrop-blur-sm hover:border hover:border-white/80 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 transform hover:scale-110 animate-pulse"
          >
            <i className="ri-whatsapp-line text-white text-2xl"></i>
          </a>
        </div>

        <Footer />
      </div>

      <DemoModal 
        isOpen={isDemoModalOpen} 
        onClose={() => setIsDemoModalOpen(false)} 
      />
    </>
  );
};

export default PackagesPage;
